import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";
import GDProjectName from "../../../../../gd-ui/project-name/project-name";


export default function FieldEventParent_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    if (!value) {
        return null
        // return (
        //     <div className="ui5-txt-less-important txt-truncate">
        //         No parent
        //     </div>
        // );
    } else {

        const showIcon = true

        return <GDProjectName className={props.className}
                              projectId={value}
                              type={showIcon ? 'with-icon' : 'default'}
                              hintFullPath={true} />

        // return <BreadcrumbsUI5 className="ultrabig-one-color" projectId={value} maxParents={2} showIcon={false} colorize={false} disabled={true}/>
    }

}
